(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-result.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-result.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  createMap,
  mapDefaults,
  sweRectangleBounds,
  worldRectangleBounds,
  locationToArray,
  getIconLeaflet,
  disableInteraction,
  getSouthCoordinate,
  checkDuplicateWagersLocations
} = svs.tur.lyckoplatsen.map;
const {
  productMapping
} = svs.lyckoplatsen.components.shared_constants;
const formatCurrency = svs.utils.format.Currency;
function getResultMapHandler() {
  let map;
  let mapId;
  let intervalPins = [];
  let wagerPins = [];
  let singleCircles;
  let singelPin;
  let singleWorldRec;
  let singleOrgWorldPath;
  let winningCoord;
  let singleWinGroups = [];
  let mapLayers = [];
  let showCenterMapButton = false;
  let showCenterWagersButton = false;
  let maxZoom;
  let minZoom;
  const trackMapLayers = e => mapLayers.push(e.layer);
  const eventHandlers = {};
  return {
    createMap(_ref) {
      let {
        mapOptions = {},
        evtHandlers = {}
      } = _ref;
      Object.assign(eventHandlers, evtHandlers);
      const options = _objectSpread(_objectSpread({}, mapDefaults), mapOptions);
      map = createMap(options);
      mapId = options.nodeId;
      maxZoom = options.maxZoom;
      minZoom = options.minZoom;
      this.handleZoomButtonsEvents();
      disableInteraction(map);
      map.on('resize', _.debounce(() => {
        this.updateUI();
      }, 300));
      return map;
    },
    handleZoomButtonsEvents() {
      map.whenReady(() => {
        const mapContainer = document.getElementById(mapId);
        const zoomInButton = mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.querySelector('.leaflet-control-zoom-in');
        const zoomOutButton = mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.querySelector('.leaflet-control-zoom-out');
        if (zoomInButton) {
          zoomInButton.addEventListener('click', () => {
            const zoomLevel = map.getZoom();
            showCenterWagersButton = true;
            showCenterMapButton = true;
            map.setView(winningCoord, zoomLevel + 1, {
              animate: false
            });
            eventHandlers.highlightedWinGroup(null);
            this.updateUI();
          });
        }
        if (zoomOutButton) {
          zoomOutButton.addEventListener('click', () => {
            const zoomLevel = map.getZoom();
            showCenterWagersButton = true;
            showCenterMapButton = true;
            map.setView(winningCoord, zoomLevel - 1, {
              animate: false
            });
            eventHandlers.highlightedWinGroup(null);
            this.updateUI();
          });
        }
      });
    },
    fitBoundsSweden() {
      var _map;
      (_map = map) === null || _map === void 0 || _map.fitBounds(sweRectangleBounds, {
        minZoom,
        maxZoom
      });
    },
    selectSinglePin() {
      var _singelPin;
      (_singelPin = singelPin) === null || _singelPin === void 0 || _singelPin.setIcon(getIconLeaflet({
        color: 'green'
      }));
      this.moveToWinGroup(0);
    },
    clearSelectedSinglePin() {
      var _singelPin2;
      (_singelPin2 = singelPin) === null || _singelPin2 === void 0 || _singelPin2.setIcon(getIconLeaflet({
        color: 'blue'
      }));
    },
    removeIntervalResult() {
      intervalPins.forEach(pin => {
        var _pin$remove;
        return pin === null || pin === void 0 || (_pin$remove = pin.remove) === null || _pin$remove === void 0 ? void 0 : _pin$remove.call(pin);
      });
      intervalPins = [];
    },
    centerMap() {
      var _singleCircles$;
      showCenterMapButton = false;
      showCenterWagersButton = true;
      const bounds = (_singleCircles$ = singleCircles[0]) === null || _singleCircles$ === void 0 ? void 0 : _singleCircles$.getBounds();
      if (bounds.isValid()) {
        var _map2;
        (_map2 = map) === null || _map2 === void 0 || _map2.fitBounds(bounds, {
          animate: false,
          padding: [45, 15],
          minZoom,
          maxZoom
        });
      }
      this.updateUI();
    },
    centerWagers() {
      var _leaflet$featureGroup, _singleCircles$2;
      showCenterMapButton = true;
      showCenterWagersButton = false;
      const winningLat = Number(winningCoord[0]);
      let hasPinAbove = false;
      let hasPinBelow = false;
      wagerPins.forEach(pin => {
        const pinLat = pin.getLatLng().lat;
        if (pinLat > winningLat) {
          hasPinAbove = true;
        }
        if (pinLat < winningLat) {
          hasPinBelow = true;
        }
      });
      const bounds = leaflet.latLngBounds([(_leaflet$featureGroup = leaflet.featureGroup(wagerPins)) === null || _leaflet$featureGroup === void 0 ? void 0 : _leaflet$featureGroup.getBounds(), (_singleCircles$2 = singleCircles[0]) === null || _singleCircles$2 === void 0 ? void 0 : _singleCircles$2.getBounds()]);
      if (bounds.isValid()) {
        var _map3;
        (_map3 = map) === null || _map3 === void 0 || _map3.fitBounds(bounds, {
          animate: false,
          paddingTopLeft: [85, hasPinAbove ? 85 : 45],
          paddingBottomRight: [85, hasPinBelow ? 85 : 15],
          minZoom,
          maxZoom
        });
      }
      this.updateUI();
    },
    moveToWinGroup(index) {
      var _singleCircles, _map4;
      const moveTo = (_singleCircles = singleCircles[singleCircles.length - 1 - index]) === null || _singleCircles === void 0 ? void 0 : _singleCircles.getBounds();
      if (!moveTo) {
        return;
      }
      const moveToCenter = moveTo.getCenter();
      const moveToZoom = map.getBoundsZoom(moveTo);
      showCenterMapButton = true;
      showCenterWagersButton = true;
      (_map4 = map) === null || _map4 === void 0 || _map4.setView([moveToCenter.lat, moveToCenter.lng], moveToZoom, {
        animate: false
      });
      this.updateUI();
    },
    showResult(_ref2) {
      let {
        winGroups,
        winningLocation,
        evtHandlers
      } = _ref2;
      map.on('layeradd', trackMapLayers);
      Object.assign(eventHandlers, evtHandlers);
      singleWinGroups = winGroups.slice().reverse();
      winningCoord = locationToArray(winningLocation);
      this.addWorldRectangle();
      this.addSinglePin();
      this.addSingleLabels();
      this.addSingleCircles();
      if (!svs.core.detect.os.iOS()) {
        this.animations();
      }
      map.off('layeradd', trackMapLayers);
    },
    showWagers(wagers, result, evtHandlers) {
      Object.assign(eventHandlers, evtHandlers);
      this.addWagerPins(wagers, result);
      if (!svs.core.detect.os.iOS()) {
        this.animationsWagers();
      }
    },
    removeWagers() {
      wagerPins = [];
    },
    addWagerPins(mapWagers, result) {
      const uniqueWagersLocations = checkDuplicateWagersLocations(mapWagers);
      const wagers = uniqueWagersLocations;
      const hasMultipleWagers = (wagers === null || wagers === void 0 ? void 0 : wagers.length) > 1;
      wagers.sort((a, b) => {
        const winAmountA = parseFloat(a.winAmount.replace(',', '.'));
        const winAmountB = parseFloat(b.winAmount.replace(',', '.'));
        return winAmountA - winAmountB;
      });
      wagerPins = wagers.map((wager, index) => {
        var _wager$wins, _wager$description, _wager$location;
        const heartPin = getIconLeaflet({
          color: 'red',
          className: 'pin-wager',
          count: wager.wagerMultiplayed
        });
        const wagerCoords = locationToArray(wager.wager.bets[0].geoBoardData.geoLoc);
        const pin = leaflet.marker(wagerCoords, {
          icon: heartPin,
          autoPanOnFocus: false
        });
        pin.setZIndexOffset((index + 1000) * (wager === null || wager === void 0 ? void 0 : wager.wagerMultiplayed));
        pin === null || pin === void 0 || pin.addTo(map);
        const matchingWin = wager === null || wager === void 0 || (_wager$wins = wager.wins) === null || _wager$wins === void 0 ? void 0 : _wager$wins.find(win => win.drawNumber === (result === null || result === void 0 ? void 0 : result.drawNumber) && productMapping.isSameProduct(win.productId, result === null || result === void 0 ? void 0 : result.productId));
        let text;
        if (matchingWin) {
          text = "Vinst: <strong>".concat(wager.wagerMultiplayed ? formatCurrency(parseFloat(matchingWin.amount.replace(',', '.')) * wager.wagerMultiplayed) : formatCurrency(matchingWin.amount), " kr</strong>");
        } else {
          const closetsWinningCircle = result === null || result === void 0 ? void 0 : result.distribution.at(-1).distanceMeters;
          const distence = svs.lyckoplatsen.utils.format.getDistance({
            from: wagerCoords,
            to: winningCoord,
            subMeter: closetsWinningCircle
          });
          text = "".concat(distence, " fr\xE5n vinst");
        }
        const content = "<strong class=\"leaflet-popup-header\">".concat((_wager$description = wager.description) !== null && _wager$description !== void 0 ? _wager$description : (_wager$location = wager.location) === null || _wager$location === void 0 ? void 0 : _wager$location.name, "</strong>").concat(text);
        const popup = leaflet.popup({
          autoClose: hasMultipleWagers,
          closeButton: hasMultipleWagers,
          closeOnClick: hasMultipleWagers,
          autoPan: false
        }).setContent(content);
        pin.bindPopup(popup);
        if (!hasMultipleWagers) {
          pin.openPopup();
        }
        pin.off('click');
        pin.on('click', () => pin.isPopupOpen() ? pin.closePopup() : pin.openPopup());
        const pinEl = pin.getElement();
        if (pinEl) {
          pinEl.addEventListener('focus', () => {
            const mapBounds = map.getBounds();
            const pinLatLng = pin.getLatLng();
            if (!mapBounds.contains(pinLatLng)) {
              this.centerWagers();
              eventHandlers.highlightedWinGroup(null);
              this.updateUI();
            }
          });
        }
        wagerPins.push(pin);
        return pin;
      });
    },
    updateUI() {
      this.uiCenterMap();
      this.uiCenterMapWagers();
      this.uiStamp();
    },
    uiCenterMap() {
      if (showCenterMapButton) {
        eventHandlers.showCenterMapButton(true);
      } else {
        eventHandlers.showCenterMapButton(false);
      }
    },
    uiCenterMapWagers() {
      if (showCenterWagersButton) {
        eventHandlers.showCenterWagersButton(true);
      } else {
        eventHandlers.showCenterWagersButton(false);
      }
    },
    uiStamp() {
      var _singleCircles$3, _singleWorldRec, _singleWorldRec2, _singleCircles$4;
      const newStampCirclePath = (_singleCircles$3 = singleCircles[0]) === null || _singleCircles$3 === void 0 ? void 0 : _singleCircles$3._path.getAttribute('d');
      const newWorldRecPath = (_singleWorldRec = singleWorldRec) === null || _singleWorldRec === void 0 ? void 0 : _singleWorldRec._path.getAttribute('d');
      (_singleWorldRec2 = singleWorldRec) === null || _singleWorldRec2 === void 0 || _singleWorldRec2._path.setAttribute('d', "".concat(newWorldRecPath, " ").concat(newStampCirclePath));
      let previousEndPath = (_singleCircles$4 = singleCircles[0]) === null || _singleCircles$4 === void 0 ? void 0 : _singleCircles$4._path.getAttribute('d');
      for (let i = 0; i < singleCircles.length; i++) {
        var _singleCircles$i, _singleCircles$i2;
        const currentEndPath = (_singleCircles$i = singleCircles[i]) === null || _singleCircles$i === void 0 ? void 0 : _singleCircles$i._path.getAttribute('d');
        (_singleCircles$i2 = singleCircles[i]) === null || _singleCircles$i2 === void 0 || _singleCircles$i2._path.setAttribute('d', "".concat(previousEndPath, " ").concat(currentEndPath));
        previousEndPath = currentEndPath;
      }
    },
    addWorldRectangle() {
      var _singleWorldRec3;
      singleWorldRec = leaflet.rectangle(worldRectangleBounds, {
        fillColor: '#001E3C',
        fillOpacity: 0.72,
        stroke: false,
        className: 'world-rect',
        renderer: leaflet.svg({
          padding: 0.85
        })
      });
      (_singleWorldRec3 = singleWorldRec) === null || _singleWorldRec3 === void 0 || _singleWorldRec3.addTo(map);
      singleOrgWorldPath = singleWorldRec._path.getAttribute('d');
      singleWorldRec.on('click', ev => {
        leaflet.DomEvent.stopPropagation(ev);
        eventHandlers.highlightedWinGroup(null);
      });
    },
    addSinglePin() {
      const heartPin = getIconLeaflet({
        color: 'blue',
        className: 'pin-single'
      });
      singelPin = leaflet.marker(winningCoord, {
        icon: heartPin
      });
      singelPin.addTo(map).on('click', ev => {
        leaflet.DomEvent.stopPropagation(ev);
        eventHandlers.highlightedWinGroup(0);
        showCenterMapButton = true;
      });
    },
    addSingleLabels() {
      const labels = [];
      map.createPane('labels');
      map.getPane('labels').style.zIndex = 401;
      singleWinGroups.forEach((circle, index) => {
        let labelDistance = circle.distanceMeters;
        if (singleWinGroups.length - 1 !== index) {
          labelDistance = circle.distanceMeters * 0.96;
        }
        const labelCoord = getSouthCoordinate(winningCoord, Math.trunc(labelDistance));
        const formattedWins = "".concat(formatCurrency(circle.winners), " ").concat(circle.winners === 1 ? 'vinst' : 'vinster');
        const myIcon = leaflet.divIcon({
          className: "label label-".concat(singleWinGroups.length - 1 - index, " ").concat(index === singleWinGroups.length - 1 || circle.distanceMeters < 850 ? '' : 'label-above', " "),
          html: "<div>".concat(formattedWins, " \xE0 ").concat(formatCurrency(circle.amountSek.slice(0, -3)), " kr<span>").concat(index === singleWinGroups.length - 1 ? 'Toppvinst' : svs.lyckoplatsen.utils.format.formatDistance(circle.distanceMeters), "</span></div>"),
          iconSize: [0, 0]
        });
        const leafletLabel = leaflet.marker(labelCoord, {
          icon: myIcon,
          pane: 'labels',
          keyboard: false
        });
        leafletLabel.addTo(map);
        labels.push(leafletLabel);
      });
    },
    addSingleCircles() {
      var _circles$, _circles$2, _eventHandlers$result;
      const circles = [];
      singleWinGroups.forEach((circle, index) => {
        const leafletCircleArea = leaflet.circle(winningCoord, {
          color: 'transparent',
          className: "stamped-area stamped-area-".concat(singleWinGroups.length - index),
          radius: circle.distanceMeters,
          renderer: leaflet.svg({
            padding: 0.85
          })
        });
        leafletCircleArea.on('add', function () {
          const path = this._path;
          const setTabIndex = index === 0 ? '-1' : '0';
          path.setAttribute('tabindex', setTabIndex);
        }).on('click', ev => {
          const currentIndex = singleWinGroups.length - index;
          leaflet.DomEvent.stopPropagation(ev);
          eventHandlers.highlightedWinGroup(currentIndex);
          showCenterMapButton = true;
          showCenterWagersButton = true;
        }).on('keypress', ev => {
          if (ev.originalEvent.key === 'Enter') {
            const currentIndex = singleWinGroups.length - index;
            leaflet.DomEvent.stopPropagation(ev);
            eventHandlers.highlightedWinGroup(currentIndex);
            showCenterMapButton = true;
            showCenterWagersButton = true;
          }
        });
        leafletCircleArea.addTo(map);
        circles.push(leafletCircleArea);
      });
      let previousPath = (_circles$ = circles[0]) === null || _circles$ === void 0 ? void 0 : _circles$._path.getAttribute('d');
      for (let i = 0; i < circles.length; i++) {
        var _circles$i, _circles$i2;
        const currentPath = (_circles$i = circles[i]) === null || _circles$i === void 0 ? void 0 : _circles$i._path.getAttribute('d');
        (_circles$i2 = circles[i]) === null || _circles$i2 === void 0 || _circles$i2._path.setAttribute('d', "".concat(previousPath, " ").concat(currentPath));
        previousPath = currentPath;
      }
      const orgCirclePath = (_circles$2 = circles[0]) === null || _circles$2 === void 0 ? void 0 : _circles$2._path.getAttribute('d');
      singleWorldRec._path.setAttribute('d', "".concat(singleOrgWorldPath, " ").concat(orgCirclePath));
      singleCircles = circles;
      (_eventHandlers$result = eventHandlers.resultRendered) === null || _eventHandlers$result === void 0 || _eventHandlers$result.call(eventHandlers);
    },
    removeResult() {
      mapLayers.forEach(layer => {
        var _layer$remove;
        return layer === null || layer === void 0 || (_layer$remove = layer.remove) === null || _layer$remove === void 0 ? void 0 : _layer$remove.call(layer);
      });
      mapLayers = [];
    },
    removeMap() {
      map.remove();
    },
    animationsWagers() {
      const tl = gsap.timeline();
      this.animationWagersHideElements(tl, mapId).then(() => this.animationWagerStart(tl, mapId)).catch(error => {
        console.error('Error:', error);
      });
    },
    animationWagersHideElements(tl, mapId) {
      return new Promise(resolve => {
        tl.set("#".concat(mapId, " .pin-wager.pin-heart svg"), {
          opacity: 0,
          height: '0px'
        });
        if (document.querySelector("#".concat(mapId, " .leaflet-popup"))) {
          tl.set("#".concat(mapId, " .leaflet-popup"), {
            opacity: 0
          });
        }
        if (document.querySelector('.gsap-heart-count')) {
          tl.set('.gsap-heart-count', {
            opacity: 0,
            scale: 0.75
          });
        }
        resolve();
      });
    },
    animationWagerStart(tl, mapId) {
      return new Promise(resolve => {
        tl.to("#".concat(mapId, " .pin-wager.pin-heart svg"), {
          opacity: 1,
          height: '80px',
          delay: 2,
          duration: 1.2,
          ease: 'elastic(1, 0.5)'
        });
        tl.to("#".concat(mapId, " .pin-wager.pin-heart svg"), {
          width: '54px',
          duration: 0.9,
          ease: 'back.out(1.2)'
        }, '<');
        if (document.querySelector('.gsap-heart-count')) {
          tl.to(".gsap-heart-count", {
            opacity: 1,
            scale: 1,
            duration: 0.375,
            ease: 'power4.out)'
          }, '>');
        }
        if (document.querySelector("#".concat(mapId, " .leaflet-popup"))) {
          tl.to("#".concat(mapId, " .leaflet-popup"), {
            opacity: 1,
            duration: 0.5,
            delay: 0.4
          }, '<');
        }
        resolve();
      });
    },
    animations() {
      const tl = gsap.timeline();
      this.animationHideElements(singleCircles, tl, mapId).then(() => this.animationStart(singleCircles, tl, mapId)).catch(error => {
        console.error('Error:', error);
      });
    },
    animationHideElements(circles, tl, mapId) {
      return new Promise(resolve => {
        tl.set("#".concat(mapId, " .pin-heart svg"), {
          opacity: 0,
          height: '0px'
        });
        tl.set("#".concat(mapId, " .world-rect"), {
          opacity: 0
        });
        circles.forEach((circle, index) => {
          tl.set("#".concat(mapId, " .stamped-area-").concat(index + 1), {
            opacity: 0,
            scale: 1
          });
        });
        resolve();
      });
    },
    animationStart(circles, tl, mapId) {
      return new Promise(resolve => {
        tl.to("#".concat(mapId, " .world-rect"), {
          opacity: 1,
          duration: 0.675
        }, '<');
        tl.to("#".concat(mapId, " .pin-single.pin-heart svg"), {
          opacity: 1,
          height: '80px',
          duration: 1.2,
          ease: 'elastic(1, 0.5)'
        });
        tl.to("#".concat(mapId, " .pin-single.pin-heart svg"), {
          width: '54px',
          duration: 0.9,
          ease: 'back.out(1.2)'
        }, '<');
        circles.forEach((circle, index) => {
          tl.to("#".concat(mapId, " .stamped-area-").concat(index + 1), {
            opacity: 1,
            scale: 1,
            duration: 0.675
          }, '<');
        });
        resolve();
      });
    }
  };
}
Object.assign(svs.lyckoplatsen.components.shared_map, {
  getResultMapHandler
});

 })(window);